import { render, staticRenderFns } from "./WikiVpc.vue?vue&type=template&id=00da888c&scoped=true"
import script from "./WikiVpc.vue?vue&type=script&lang=js"
export * from "./WikiVpc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00da888c",
  null
  
)

export default component.exports